export default {
  type: 'FeatureCollection',
  name: 'Green Zones',
  crs: {
    type: 'name',
    properties: {
      name: 'urn:ogc:def:crs:OGC:1.3:CRS84',
    },
  },
  features: [
    {
      type: 'Feature',
      properties: {
        Name: 'Львів',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.013943, 49.769242],
            [24.032011, 49.768106],
            [24.033421, 49.76798],
            [24.034418, 49.767873],
            [24.034212, 49.768569],
            [24.034746, 49.769407],
            [24.034832, 49.770904],
            [24.035433, 49.770848],
            [24.035433, 49.771901],
            [24.037407, 49.772012],
            [24.037836, 49.775116],
            [24.034661, 49.775726],
            [24.035572, 49.778554],
            [24.039553, 49.777333],
            [24.04127, 49.782211],
            [24.038094, 49.783208],
            [24.039295, 49.785591],
            [24.040894, 49.785648],
            [24.043469, 49.787089],
            [24.042096, 49.788197],
            [24.044156, 49.789084],
            [24.047589, 49.789195],
            [24.047761, 49.787532],
            [24.049477, 49.787311],
            [24.049477, 49.785537],
            [24.051537, 49.78587],
            [24.051881, 49.78066],
            [24.061322, 49.780771],
            [24.070935, 49.780993],
            [24.07969, 49.783542],
            [24.091019, 49.779441],
            [24.107541, 49.783874],
            [24.092736, 49.794514],
            [24.081406, 49.801938],
            [24.081235, 49.805151],
            [24.078488, 49.806148],
            [24.077973, 49.807588],
            [24.079518, 49.807366],
            [24.08072, 49.808918],
            [24.079175, 49.809914],
            [24.081235, 49.810801],
            [24.083466, 49.810025],
            [24.087414, 49.810468],
            [24.089303, 49.815675],
            [24.092393, 49.81944],
            [24.091363, 49.821102],
            [24.093766, 49.82232],
            [24.097952, 49.822587],
            [24.099754, 49.822809],
            [24.101299, 49.822864],
            [24.103617, 49.824193],
            [24.118466, 49.824969],
            [24.119988, 49.824954],
            [24.120782, 49.825051],
            [24.124216, 49.825855],
            [24.128486, 49.826463],
            [24.112476, 49.833172],
            [24.112992, 49.833283],
            [24.112649, 49.838376],
            [24.111619, 49.839704],
            [24.114194, 49.840922],
            [24.115224, 49.840147],
            [24.118142, 49.841365],
            [24.11797, 49.843136],
            [24.113507, 49.843911],
            [24.104581, 49.842361],
            [24.103722, 49.84369],
            [24.095483, 49.846014],
            [24.098401, 49.847786],
            [24.099602, 49.851549],
            [24.093766, 49.852213],
            [24.092564, 49.853541],
            [24.089303, 49.854094],
            [24.089818, 49.855312],
            [24.082093, 49.859407],
            [24.083981, 49.862616],
            [24.091363, 49.863833],
            [24.08793, 49.86494],
            [24.089174, 49.870555],
            [24.088093, 49.873266],
            [24.086385, 49.873542],
            [24.084496, 49.873625],
            [24.083295, 49.873708],
            [24.078394, 49.87429],
            [24.077973, 49.874012],
            [24.063554, 49.875893],
            [24.061322, 49.881092],
            [24.059463, 49.886132],
            [24.049706, 49.889624],
            [24.040464, 49.892672],
            [24.035341, 49.892403],
            [24.029954, 49.895749],
            [24.022269, 49.897795],
            [24.022322, 49.896332],
            [24.019627, 49.895753],
            [24.019046, 49.892163],
            [24.016853, 49.891398],
            [24.015213, 49.890696],
            [24.013395, 49.887136],
            [24.011904, 49.884439],
            [24.009093, 49.882918],
            [24.008021, 49.881479],
            [24.001841, 49.877829],
            [23.998922, 49.876612],
            [23.997936, 49.876032],
            [23.996906, 49.876086],
            [23.995404, 49.876197],
            [23.993858, 49.873818],
            [23.992872, 49.873874],
            [23.99328, 49.87516],
            [23.991778, 49.875423],
            [23.991392, 49.874551],
            [23.991134, 49.874317],
            [23.990297, 49.874579],
            [23.988924, 49.874662],
            [23.983988, 49.873127],
            [23.986821, 49.875395],
            [23.984246, 49.874455],
            [23.978066, 49.875893],
            [23.974976, 49.878105],
            [23.966565, 49.878105],
            [23.966565, 49.879101],
            [23.958668, 49.881203],
            [23.943906, 49.880981],
            [23.943391, 49.879543],
            [23.944764, 49.879212],
            [23.943047, 49.87722],
            [23.942125, 49.874261],
            [23.937597, 49.874579],
            [23.933456, 49.873155],
            [23.924079, 49.874261],
            [23.923714, 49.872975],
            [23.923306, 49.872989],
            [23.923027, 49.873044],
            [23.922019, 49.873127],
            [23.915581, 49.87357],
            [23.912319, 49.86837],
            [23.91068, 49.8658196],
            [23.91068, 49.865709],
            [23.9117185, 49.865991],
            [23.919263, 49.8652528],
            [23.9155811, 49.8539838],
            [23.9227055, 49.8522681],
            [23.9245943, 49.8520881],
            [23.9270268, 49.851952],
            [23.9344217, 49.8507189],
            [23.9384979, 49.8495568],
            [23.9446599, 49.8468953],
            [23.9490191, 49.845064],
            [23.9483864, 49.8440511],
            [23.9463697, 49.8438962],
            [23.9438745, 49.8437269],
            [23.9412352, 49.8426752],
            [23.9331457, 49.8438929],
            [23.9308283, 49.8424261],
            [23.9303133, 49.8406133],
            [23.9224383, 49.8395201],
            [23.9180539, 49.839246],
            [23.909745, 49.8380992],
            [23.902706, 49.83356],
            [23.903994, 49.831622],
            [23.905754, 49.829462],
            [23.907805, 49.826984],
            [23.909831, 49.823843],
            [23.910389, 49.823316],
            [23.910775, 49.823095],
            [23.912397, 49.82045],
            [23.914423, 49.819302],
            [23.919873, 49.814567],
            [23.92086, 49.81357],
            [23.922963, 49.811355],
            [23.924293, 49.811133],
            [23.925366, 49.811022],
            [23.92778, 49.810534],
            [23.931718, 49.80925],
            [23.938584, 49.809139],
            [23.951459, 49.807699],
            [23.952832, 49.807145],
            [23.95575, 49.807477],
            [23.962102, 49.804929],
            [23.962445, 49.802603],
            [23.959623, 49.798735],
            [23.964122, 49.797656],
            [23.96468, 49.790536],
            [23.96438, 49.786656],
            [23.968585, 49.78649],
            [23.968929, 49.785271],
            [23.977598, 49.785604],
            [23.987039, 49.783221],
            [23.987382, 49.786213],
            [23.99176, 49.785659],
            [23.99133, 49.783221],
            [23.992618, 49.783165],
            [23.99545, 49.78638],
            [23.998197, 49.786601],
            [23.999141, 49.787432],
            [24.008926, 49.787377],
            [24.008926, 49.786934],
            [24.00987, 49.786712],
            [24.010127, 49.787543],
            [24.01193, 49.787543],
            [24.012227, 49.783764],
            [24.012874, 49.779784],
            [24.011883, 49.777362],
            [24.011518, 49.774729],
            [24.008032, 49.774716],
            [24.007962, 49.771411],
            [24.007948, 49.769647],
            [24.013943, 49.769242],
          ],
        ],
      },
    },
  ],
};
